<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.exclamation-triangle-duotone"></svg-vue>
          <h1 class="content-title">
            {{ $t('Out of stock alerts') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app rounded-md" to="/admin">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <div class="w-full px-5 py-2">
          <table>
            <thead>
              <tr class="w-full text-left text-xs">
                <th class="w-5/6 px-5">{{$t('Name')}}</th>
                <th class="px-5">{{$t('In stock')}}</th>
                <th class="px-5">{{$t('Sold')}}</th>
                <th class="px-5">{{$t('Alerted at')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-t text-gray-700" v-for="(alert,index) in alerts" :key="index">
                <td class="px-5">{{alert.name}}</td>
                <td class="px-5 text-blue-600">{{alert.qty}}</td>
                <td class="px-5 text-green-600">{{alert.sold}}</td>
                <td class="px-5 text-red-600">{{alert.alert_at}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'report',
  metaInfo() {
    return {
      title: this.$i18n.t('Out of stock alerts'),
    };
  },
  data() {
    return {
      loading: false,
      alerts: [],
    };
  },
  mounted(){
    this.getOutOfStocks()
  },
  methods: {
    getOutOfStocks() {
      this.loading = true;
      axios.get(route('get-stock-alerts')).then((response) => {
        this.alerts = response.data;
        this.loading = false;
      });
    },
  },
};
</script>
